import React from "react";
import { makeStyles } from "@material-ui/core";
import PacketDocument from "./PacketDocument";
import Document from "../../types/Document";

interface IProps {
  documents: Document[];
  onDocumentClick: (document: Document) => void;
  selectedDocumentId: string;
}

export default function PacketDocumentList(props: IProps) {
  const { documents, onDocumentClick, selectedDocumentId } = props;
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {documents &&
        documents.map((document, index) => (
          <PacketDocument
            key={document.documentId}
            document={document}
            index={index}
            onClick={onDocumentClick}
            selectedDocumentId={selectedDocumentId}
          />
        ))}
    </div>
  );
}

const useStyles = makeStyles(theme => ({
  container: {
    position: "relative"
  }
}));
